import { render, staticRenderFns } from "./public-footer.component.html?vue&type=template&id=444ea990&"
import script from "./public-footer.component.ts?vue&type=script&lang=ts&"
export * from "./public-footer.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports